// Local library
import { DepositAddAccountCardService, IDebitCreditCard } from '@amwager/funding/data-access';
import { UnsubscribeObservableService,
TranslatePipe
} from '@amwager/util';
import { IDCCard, LoggerService } from '@amwager/util-ts';

// Angular
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

// Material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Third party
import { Subscription, interval, startWith, takeUntil } from 'rxjs';

// from JS eProtect iFrame CDN
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let EprotectIframeClient: any; // class
declare let iframeIsReady: boolean | undefined; // property

// will determine if data is to submit,
// set this to null if you don't want to submit
let callbackDataResponse: IDCCard | undefined = undefined;
// let $timeout = null;
let showErrorMsg: string;


@Component({
  selector: 'feature-mat-add-account-card',
  templateUrl: './add-account-card.component.html',
  styleUrls: ['./add-account-card.component.scss'],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    TranslatePipe
  ],
  standalone: true,
  providers: [DepositAddAccountCardService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddAccountCardComponent extends UnsubscribeObservableService
  implements OnInit, OnChanges, OnDestroy {

  @Input() showAddCard: boolean = false;
  @Output() showAddCardFn = new EventEmitter<boolean>();

  @ViewChild('eProtectIframeTemplate') eProtectIframeTemplate!: ElementRef;
  @ViewChild('eProtectiframe') eProtectiframe!: ElementRef;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eProtectiframeClient: any;

  $invervalIframeIsReady!: Subscription;
  $isEProtectURLLoaded!: Subscription;


  private subsAddCardResponse!: Subscription;
  isIFrameReady: boolean = false;

  isEProtectURLLoaded: boolean = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cardAccountValidCheckerTimeout: any;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly loggerService: LoggerService,
    private readonly addAccountCardService: DepositAddAccountCardService,
  ) {
    super();
  }

  ngOnChanges(): void {
    if (this.showAddCard) this.loadCDNs();
    else {
      this.isEProtectURLLoaded = false;
      this.isIFrameReady = false;
      this.clearStateProcess();
      this.removeCDNs();
      this.cdRef.markForCheck();
    }
  }

  ngOnInit(): void {
    null;
  }

  override ngOnDestroy(): void {
    this.isEProtectURLLoaded = false;
    this.clearStateProcess();
    this.removeCDNs();
  }

  addBtnState(state: boolean = true): void {
    // show btn add or adding

    if (!this.eProtectIframeTemplate) return;

    if (state) { // show adding
      this.eProtectIframeTemplate.nativeElement.children['btn-account'].children['btn-add'].hidden = true;
      this.eProtectIframeTemplate.nativeElement.children['btn-account'].children['btn-adding'].hidden = false;
    }
    else { // show add
      this.eProtectIframeTemplate.nativeElement.children['btn-account'].children['btn-add'].hidden = false;
      this.eProtectIframeTemplate.nativeElement.children['btn-account'].children['btn-adding'].hidden = true;
    }
  }

  loadCDNs(): void {
    if (this.isEProtectURLLoaded) return;

    this.clearStateProcess();
    this.removeCDNs();

    // OLD (script list moved to DepositAddAccountCardService.addEProtectScripts):
    // const scriptsToAdd = [
    //   { id: 'JQueryCDN', url: this.eProtect.jQuery },
    //   { id: 'eProtectCDN', url: this.eProtect.url }
    // ];
    // this.loadService.addScripts(scriptsToAdd)
    this.addAccountCardService.addEProtectScripts()
    .then(() => {
      this.loggerService.log('EProtect scripts added successfully!');

      this.isEProtectURLLoaded = true;
      this.cdRef.markForCheck();

      this.eProtectIframeClientIsReadyChecker();
    })
    .catch(error => {
      this.loggerService.log('ERROR: EProtect scripts loading failed:', error);

      this.isEProtectURLLoaded = false;
      this.cdRef.markForCheck();
    });
  }


  removeCDNs(): void {
    if (!this.isEProtectURLLoaded) return;

    // OLD (script list moved to DepositAddAccountCardService.removeEProtectScripts):
    // const scriptsToRemove = ['JQueryCDN','eProtectCDN'];
    // this.loadService.removeScripts(scriptsToRemove)
    this.addAccountCardService.removeEProtectScripts()
    .then(() => {
      this.loggerService.log('EProtect scripts removed successfully!');

      this.isEProtectURLLoaded = false;
      this.cdRef.markForCheck();
    })
    .catch(error => {
      this.loggerService.log('ERROR: EProtect scripts removal failed:', error);
    });
  }

  clearStateProcess(): void {

    if (this.$invervalIframeIsReady) this.$invervalIframeIsReady.unsubscribe();
    if (this.$isEProtectURLLoaded) this.$isEProtectURLLoaded.unsubscribe();
    if (this.cardAccountValidCheckerTimeout) clearTimeout(this.cardAccountValidCheckerTimeout);

    this.eProtectiframeClient = undefined;
    if (typeof iframeIsReady !== 'undefined') iframeIsReady = undefined;
    callbackDataResponse = undefined;

    this.cdRef.markForCheck();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputsEmptyCallBack(response: any): void {
    null;
  }

  eProtectConfigureSettings(): void {
    if (!EprotectIframeClient) {
      this.showAddCardFn.emit(false);
      this.showAlertMessage('Error', 'EProtect failure. Kindly contact support.');
      return;
    }

    try {
      // OLD (config building moved to DepositAddAccountCardService.buildEProtectConfig):
      // this.eProtectiframeClient = new EprotectIframeClient(
      //   eProtectConfigure(
      //     this.sessionService.getPayPageId(),
      //     this.eProtect.css,
      //     this.eProtect.reportGroup,
      //     this.eProtectIframeClientCallBack,
      //     this.inputsEmptyCallBack
      //   )
      // );
      this.eProtectiframeClient = new EprotectIframeClient(
        this.addAccountCardService.buildEProtectConfig(
          this.eProtectIframeClientCallBack,
          this.inputsEmptyCallBack
        )
      );

      this.eProtectiframeClient.autoAdjustHeight();
    } catch (error) {
      this.loggerService.log("ERROR:", error);
    }


    this.iFrameIsReadyChecker();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eProtectIframeClientCallBack(response: any): void {
    const EXPIRATION_DATE_EXPIRED: string = "Card can't be added. Card is already expired.";

    if (response.response == 870) {
      if (String(response.type).toLowerCase() === 'vi' ||
          String(response.type).toLowerCase() === 'mc'
        ) {
        if (!response.expMonth || !response.expYear) showErrorMsg = EXPIRATION_DATE_EXPIRED;

        callbackDataResponse = {
          "OrderId": response.orderId,
          "Id": response.id,
          "PaypageRegistrationId": response.paypageRegistrationId,
          "Bin": response.bin,
          "ExpMonth": response.expMonth,
          "ExpYear": response.expYear,
          "FirstSix": response.firstSix,
          "LastFour": response.lastFour,
          "InvokeMerchantCallback": response.invokeMerchantCallback,
          "Message": response.message,
          "ReportGroup": response.reportGroup,
          "Response": response.response,
          "ResponseTime": response.responseTime,
          "TargetServer": response.targetServer,
          "Type": response.type,
          "VantivTxnId": response.vantivTxnId
        };
      }
      else {
        showErrorMsg = "Could not add card, please try again later or contact support."
      }
    }
    else {
      showErrorMsg = response.message || (response?.timeout ? 'Timeout' : 'unknown issue');
    }
  }

  eProtectIframeClientIsReadyChecker(): void {
    this.$isEProtectURLLoaded = interval(500).pipe(startWith(0)).subscribe( () => {

      if (EprotectIframeClient) { // EprotectIframeClient is loaded
        setTimeout(() => {
          this.eProtectConfigureSettings();
          this.addBtnState(false);
        }, 300);

        if (this.$isEProtectURLLoaded) this.$isEProtectURLLoaded.unsubscribe();
      }
    });
  }

  iFrameIsReadyChecker(): void {
    this.$invervalIframeIsReady = interval(500).pipe(startWith(0)).subscribe( () => {

      if (iframeIsReady) { // Iframe is loaded
        setTimeout(() => {
          this.isIFrameReady = Boolean(iframeIsReady);
        }, 300);
        if (this.$invervalIframeIsReady) this.$invervalIframeIsReady.unsubscribe();
        this.cardAccountValidChecker();

        this.cdRef.markForCheck();
      }
      else if (!this.eProtectIframeTemplate && showErrorMsg) {
        this.showAlertMessage('Error', showErrorMsg);
        showErrorMsg = '';
      }
    });
  }

  cardAccountValidChecker(): void {
    if (!this.showAddCard) {
      if (this.cardAccountValidCheckerTimeout) clearTimeout(this.cardAccountValidCheckerTimeout);
      return;
    }

    if (showErrorMsg && this.showAddCard) {
      this.showAlertMessage('Error', showErrorMsg);
      showErrorMsg = '';
    }

    // submit/send to api if callbackDataResponse has data
    if (callbackDataResponse) this.insertCard(callbackDataResponse);
    else {
      this.cardAccountValidCheckerTimeout = setTimeout(() => {
        this.cardAccountValidChecker();
      }, 500);
    }
  }

  insertCard(newCard: IDebitCreditCard): void {
    callbackDataResponse = undefined

    // OLD (dispatch + success stream moved to DepositAddAccountCardService.insertCard$):
    // this.fundingFacade.addDebitCreditCard(newCard);
    // this.subsAddCardResponse = this.fundingFacade.isAddDebitCreditCardSuccess$()
    this.subsAddCardResponse?.unsubscribe();
    this.subsAddCardResponse = this.addAccountCardService.insertCard$(newCard)
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe(({response, isSuccess}) => {
      this.addBtnState(false);
      this.clearStateProcess();

      if (!isSuccess && response?.error) {
        this.showAlertMessage('Error' ,response?.error?.Message || 'Error');
      }
    });
  }


  addCard(): void {
    if (!this.eProtectiframeClient) {
      this.loggerService.log('ERROR: no eProtectiframeClient')
      return;
    }

    this.addBtnState(true);

    // OLD (session id generation moved to DepositAddAccountCardService.buildRegistrationMessage):
    // const id = this.sessionService.generateSessionId();
    // const orderId = this.sessionService.generateSessionId();
    // const message = {
    //   "id":  btoa(id).substring(0,24), //unique, max 25
    //   "orderId": btoa(orderId).substring(0, 24), //unique, max 256
    // };
    const message = this.addAccountCardService.buildRegistrationMessage();

    this.eProtectiframeClient.getPaypageRegistrationId(message);
  }

  showAlertMessage(header: string, message: string): void {
    this.addBtnState(false);

    // OLD (moved to DepositAddAccountCardService.showAlert):
    // this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
    this.addAccountCardService.showAlert(header, message);
  }

}
